import { createReducers } from '@customd/cd-redux-helpers/dist/reducers';

export default createReducers('favourites', ['ids']);

export const getFavourites = state => state.ids;
export const getIsFavourite = (state, galleryId) => {
  return state.ids.indexOf(galleryId) >= 0;
};
